import { Tabs } from './Tabs';

export const initTabs = () => {
  //   Tabs START
  const tabsParent = document.querySelectorAll('[data-tabs="parent"]');
  if (tabsParent.length > 0) {
    tabsParent.forEach((tab) => {
      if (tab.dataset.destroy && !window.matchMedia(tab.dataset.destroy).matches) {
        tab.classList.add('tabs--destroy');
        return;
      } else {
        const tabs = new Tabs();
        window.tabs = tabs;
      }
    });
  }

  //   Tabs END
};
